import { LineHelper } from '../../../../../../../helpers/line.helper';
import { TransportModeHelper } from '../../../../../../../helpers/transport-mode.helper';
import { TransportMode } from '../../../../../../../models/transport-mode.enum';
import { SanitizerService } from '../../../../../../../services/sanitizer.service';
import { TranslationService } from '../../../../../../../services/translation.service';

export default class LabelHelper {
  public static createIconHtml(
    transportMode: TransportMode,
    timeString: string | undefined,
    line: { name: string | undefined; foregroundColor: string | undefined; backgroundColor: string | undefined; borderColor: string | undefined } | undefined,
    isCancelled: boolean,
  ): string {
    if (!transportMode && !line && !timeString) return '';

    let result = '<div class="bg-white rounded d-flex align-items-center small" style="padding: 0.125rem 0.25rem">';

    if (line) {
      result += `<span class="visually-hidden">${transportMode === TransportMode.train ? TranslationService.get('common.trainnumber') : TranslationService.get('common.line')}</span>`;
      result += `<span class="fw-bold text-center rounded border text-nowrap"
      style="min-width: 1.5rem; padding: 0 0.125rem; ${LabelHelper.getLineLabelColorStyle(line)} ${LabelHelper.getLineLabelBorderStyle(line)}">
        ${line.name ? SanitizerService.sanitizeHtml(line.name) : ''}
      </span>`;
    }

    const transportModeIconSource = LabelHelper.getTransportModeIconSource(transportMode);
    if (transportModeIconSource) {
      result += `<img
            src="${transportModeIconSource}"
            alt="${TransportModeHelper.translate(transportMode)}"
            class="me-1"
            style="height:1.5rem"
        />`;
    }

    if (timeString && !isCancelled) {
      result += `<span class="fw-bold">${timeString}</span>`;
    }

    if (timeString && isCancelled) {
      result += `<span class="fw-bold text-danger me-1 text-line-through">${timeString}</span>`;
      result += `<span class="fw-bold text-danger">${TranslationService.get('common.cancelled')}</span>`;
    }

    result += '</div>';

    return result;
  }

  private static getLineLabelBorderStyle(line: { foregroundColor: string | undefined; backgroundColor: string | undefined; borderColor: string | undefined }): string {
    if (!line) return '';
    return `border-color: ${SanitizerService.sanitizeHtml(LineHelper.getBorderColor(line))} !important;`;
  }

  private static getLineLabelColorStyle(line: { foregroundColor: string | undefined; backgroundColor: string | undefined }): string {
    if (!line) return '';
    return `color: ${SanitizerService.sanitizeHtml(LineHelper.getForegroundColor(line))}; background-color: ${SanitizerService.sanitizeHtml(LineHelper.getBackgroundColor(line))};`;
  }

  private static getTransportModeIconSource(transportMode: TransportMode): string {
    // The svgs are placed in the wwwroot/icons folder (i.e. not copied by vite from the assets folder at build time)
    const folder = '/icons/leaflet';
    if (transportMode === TransportMode.train) {
      return `${folder}/train-default-gray-900.svg`;
    }
    if (transportMode === TransportMode.bus) {
      return `${folder}/bus-default-gray-900.svg`;
    }
    if (transportMode === TransportMode.tram) {
      return `${folder}/tram-default-gray-900.svg`;
    }
    if (transportMode === TransportMode.ferry) {
      return `${folder}/ferry-default-gray-900.svg`;
    }
    if (transportMode === TransportMode.walk) {
      return `${folder}/walk-default-gray-900.svg`;
    }
    if (transportMode === TransportMode.bike) {
      return `${folder}/bike-default-gray-900.svg`;
    }
    if (transportMode === TransportMode.car) {
      return `${folder}/car-default-gray-900.svg`;
    }
    return '';
  }
}
